export default "__VITE_ASSET__BhOhj_h7__"